import React, { useContext } from 'react';

import { type ProfileCardClientConfigProviderState } from './types';

const error = new Error('ProfileCardClientConfigProvider is not found in higher components');

const defaultState: ProfileCardClientConfigProviderState = {
	addFlag: () => {
		// eslint-disable-next-line no-console
		console.error(error);
	},
	push: () => {
		// eslint-disable-next-line no-console
		console.error(error);
	},
	contextEntryPoint: null,
	cloudId: null,
};

export const ProfileCardClientConfigContext =
	React.createContext<ProfileCardClientConfigProviderState>(defaultState);

export const useProfileCardClientConfig = () =>
	useContext<ProfileCardClientConfigProviderState>(ProfileCardClientConfigContext);
